import { useSelector } from 'react-redux';

import { getPermissions } from '../redux/authority/selectors';

/**
 * Retrieves the user's permissions.
 */
export default () => useSelector(getPermissions);
